// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import MobileMenuController from "./mobile_menu_controller";
application.register("mobile-menu", MobileMenuController);

import HelloController from "./hello_controller";
application.register("hello", HelloController);

import ScrollRevealController from "./scroll_reveal_controller";
application.register("scroll-reveal", ScrollRevealController);

import DottedMapController from "./dotted_map_controller";
application.register("dotted-map", DottedMapController);

import RecommendationRotatorController from "./recommendation_rotator_controller";
application.register("recommendation-rotator", RecommendationRotatorController);

import ScreenshotModalController from "./screenshot_modal_controller";
application.register("screenshot-modal", ScreenshotModalController);

import DarkModeController from "./dark_mode_controller";
application.register("dark-mode", DarkModeController);

import BookingController from "./booking_controller";
application.register("booking", BookingController);

import PricingController from "./pricing_controller";
application.register("pricing", PricingController);

import PricingCtaController from "./pricing_cta_controller";
application.register("pricing-cta", PricingCtaController);

import HeroCtaController from "./hero_cta_controller";
application.register("hero-cta", HeroCtaController);

import ProjectTrackingController from "./project_tracking_controller";
application.register("project-tracking", ProjectTrackingController);

import RecommendationTrackingController from "./recommendation_tracking_controller";
application.register("recommendation-tracking", RecommendationTrackingController);
